<template>
    <main-layout>
        <div class="kkv">
            <div class="kkv__menu">
                <router-link to="/kkv/orders/" active-class="a-active">Orders</router-link>
                <router-link to="/kkv/whatsapp/" active-class="a-active">
                  WhatsApp
                  <span class="whatsapp-menu-count">{{ whatsappUnreadCount }}</span>
                </router-link>
                <router-link to="/kkv/whatsapp-settings/" active-class="a-active">WhatsApp Einstellungen</router-link>
                <router-link to="/kkv/prices/" active-class="a-active">Prices</router-link>
                <router-link to="/kkv/resellers/" active-class="a-active">Resellers</router-link>
              <router-link to="/kkv/promo_codes/" active-class="a-active">Gutscheincode</router-link>
                <router-link to="/kkv/emails_templates/" active-class="a-active">Emails templates</router-link>
                <router-link to="/kkv/content_texts/" active-class="a-active">Content texts</router-link>
                <router-link to="/kkv/disabled_dates/" active-class="a-active">Inactive dates</router-link>
                <router-link to="/kkv/csv/" active-class="a-active">CSV</router-link>
                <router-link to="/kkv/info/" active-class="a-active">Info</router-link>
            </div>
            <div class="kkv__body">
                <router-view></router-view>
            </div>
        </div>
    </main-layout>

</template>

<script>
import MainLayout from "./main-layout"
import {makeJsonRequest} from "@/plugins/transport"

export default {
  name: "kkv-layout",
  components: {MainLayout},
  data: () => ({whatsappUnreadCount: 0, whatsappUnreadInterval: null}),
  mounted () {
    this.refreshWhatsappUnreadCount()
    this.whatsappUnreadInterval = window.setInterval(this.refreshWhatsappUnreadCount, 15000)
    window.addEventListener("whatsapp-pending-updated", this.refreshWhatsappUnreadCount)
  },
  beforeDestroy () {
    window.clearInterval(this.whatsappUnreadInterval)
    window.removeEventListener("whatsapp-pending-updated", this.refreshWhatsappUnreadCount)
  },
  methods: {
    async refreshWhatsappUnreadCount () {
      try {
        const response = await makeJsonRequest({
          url: "/call_method/", method: "POST",
          data: {service_name: "whatsapp", method_name: "get_unread_count", arguments: []}
        })
        const payload = await response.json()
        this.whatsappUnreadCount = payload.status === "ok"
          ? Number(payload.result && payload.result.count) || 0
          : 0
      } catch (error) {
        this.whatsappUnreadCount = 0
      }
    }
  }
}
</script>

<style lang="stylus">
    .kkv
        &__menu
            background-color #F1932A
            padding 3px 0 2px 0
            a
                color #fefefe
                margin 0 10px 0 5px
                font-size 1.1em

.whatsapp-menu-count
  display inline-flex
  align-items center
  justify-content center
  min-width 18px
  height 18px
  margin-left 5px
  padding 0 5px
  border-radius 9px
  background #d71920
  color #fff
  font-size 12px
  font-weight bold
  line-height 18px
</style>
